import { FieldValues, FieldPath, Control, RegisterOptions, Controller } from 'react-hook-form';
import { AppDateRangeField, DateRangeProps } from '../fields/daterange/dateRangeField';

type HookFormDateRangeFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<DateRangeProps, 'startDate' | 'endDate' | 'onStartChange' | 'onEndChange'> & {
  name: TName;
  control: Control<TFieldValues>;
  rules?: Exclude<RegisterOptions, 'valueAsDate' | 'setValueAs'>;
  onFocus?: () => void;
  defaultValue?: unknown;
};

export const HookFormDateRangeField = (props: HookFormDateRangeFieldProps) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      rules={props.rules}
      defaultValue={props.defaultValue ?? [null, null]}
      render={({ field: { value, onChange, ref }, formState: { isSubmitting } }) => (
        <div tabIndex={0} ref={ref}>
          <AppDateRangeField
            {...props}
            disabled={props.disabled || isSubmitting}
            startDate={value?.[0] || ''}
            endDate={value?.[1] || ''}
            onStartChange={(e) => onChange([e.target.value || null, value?.[1]])}
            onEndChange={(e) => onChange([value?.[0], e.target.value || null])}
          />
        </div>
      )}
    />
  );
};
